const archives = ["executed", "archivecust", "archivecarrier", "archagreement"]; // Статусы которые попадают в общую группу архив

export const adjustRequestData = request => {
  const status = request.requestStatusId;
  const profile = request.profileId;
  const company = profile && profile.companyId;
  const requestType = request.requestTypeId;
  const view = request.requestViewId;
  let newData = {
    number: request.number,
    id: request.requestId,
    info: {
      requestNumber: request.number,
      create: request.createdAt,
      change: request.updatedAt
    },
    view: {
      id:
        request && request.serviceTypeId && request.serviceTypeId.serviceTypeId,
      abbr:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeAbbr,
      key:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeKey,
      type:
        request && request.serviceTypeId && request.serviceTypeId.serviceType,
      color: "",
      description: ""
    },
    state: {
      status: status && status.requestStatus,
      statusKey: status && status.requestStatusKey,
      statusId: status && status.requestStatusId,
      statusKeyGroup: status && status.requestStatusKey,
      color: "",
      description: ""
    },
    requestView: {
      view: view && view.requestView.split(" ")[0],
      viewKey: view && view.requestViewKey,
      viewId: view && view.requestViewId,
      viewKeyGroup: view && view.requestViewKey
    },
    requestType: {
      requestType: requestType && requestType.requestType,
      requestTypeId: requestType && requestType.requestTypeId,
      requestTypeKey: requestType && requestType.requestTypeKey
    },
    passengers: request.passengersCount,
    kids: request.kidsCount,
    accompCount: request.accompCount,
    customer: {
      name: company && company.name ? company.name : null,
      lastname: company && company.lastname ? company.lastname : null,
      patronymic: company && company.patronymic ? company.patronymic : null,
      nameLegal: company && company.nameLegal ? company.nameLegal : null,
      subject:
        company && company.subjectId && company.subjectId.subject
          ? company.subjectId.subject
          : null,
      subjectAbbr:
        company && company.subjectId && company.subjectId.subjectAbbr
          ? company.subjectId.subjectAbbr
          : null,
      subjectId:
        company && company.subjectId && company.subjectId.subjectId
          ? company.subjectId.subjectId
          : null,
      subjectKey:
        company && company.subjectId && company.subjectId.subjectKey
          ? company.subjectId.subjectKey
          : null
    },
    routeLength: request.routes && request.routes.length,
    arrivalDatetime: request.arrivalDatetime,
    placeDelivery: {
      city:
        request.routes && request.routes.length
          ? request.routes[0].route.split(",")[0]
          : "Не указано",
      address:
        request.routes && request.routes.length
          ? request.routes[0].route
              .split(",")
              .slice(1)
              .join(",")
          : ""
    },
    finalDestination: {
      city:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route.split(",")[0]
          : "Не указано",
      address:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route
              .split(",")
              .slice(1)
              .join(",")
          : ""
    },
    settlementForm: {
      id: request.paymentMethodId
        ? request.paymentMethodId.paymentMethodId
        : null,
      description: request.paymentMethodId
        ? request.paymentMethodId.paymentMethod
        : null
    },
    region: {
      id:
        request.routes && request.routes.length
          ? request.routes[0].regionId
          : ""
    },
    dayOfWeeks: {
      days:
        request.dayOfWeeks && request.dayOfWeeks.length > 0
          ? request.dayOfWeeks[0]
          : ""
    },
    watched: !!request.viewLog,
    map: null
    // driver:
    //   request.profileId &&
    //   request.profileId.roleId === 6
  };
  if (request.routes && request.routes.length > 0) {
    newData.map = {
      id: request.requestId,
      article: request.number,
      dateApplication: request.arrivalDatetime,
      address: request.routes[0].route,
      latlng:
        request.routes[0].latitude && request.routes[0].longitude
          ? [+request.routes[0].latitude, +request.routes[0].longitude]
          : null
    };
  }
  if (archives.some(key => key === newData.state.statusKeyGroup)) {
    newData.state.statusKeyGroup = "archive";
  }

  if (!newData.passengers && newData.kids && newData.accompCount) {
    newData.passengers = parseInt(newData.kids) + parseInt(newData.accompCount);
  } else if (!newData.passengers && newData.kids && !newData.accompCount) {
    newData.passengers = parseInt(newData.kids);
  }
  // последняя проверка наверное не имеет смысла, поэтому в будущем, возможно выпилю
  else if (!newData.passengers && newData.accompCount && !newData.kids) {
    newData.passengers = parseInt(newData.accompCount);
  }

  return newData;
};

export const dataAdjustmentFiltersRequest = filters => {
  let newData = {};
  if (!!filters.search) {
    newData.search_entry = filters.search;
  }
  if (filters.page) {
    newData.page = filters.page;
  }

  if (filters.limit) {
    newData.limit = filters.limit;
  }

  if (filters.requestTypes) {
    newData["request_type_key"] = filters.requestTypes;
  }

  if (filters.replied) {
    if (newData["request_status_key"]) {
      newData["request_status_key"].push(filters.replied);
    } else {
      newData["request_status_key"] = [];
      newData["request_status_key"].push(filters.replied);
    }
  }
  if (filters.watched) {
    if (newData["request_status_key"]) {
      newData["request_status_key"].push(filters.watched);
    } else {
      newData["request_status_key"] = [];
      newData["request_status_key"].push(filters.watched);
    }
  }

  if (filters.type) {
    if (newData["request_status_key"]) {
      newData["request_status_key"].push(filters.type);
    } else {
      newData["request_status_key"] = [];
      newData["request_status_key"].push(filters.type);
    }
  }

  if (filters.searchField) {
    newData.search_entry = filters.searchField;
  }

  if (filters.serviceTypes) newData.service_type_key = filters.serviceTypes;
  if (filters.passengersMin)
    newData["passengers_count[from]"] = filters.passengersMin;
  if (filters.passengersMax)
    newData["passengers_count[to]"] = filters.passengersMax;
  if (filters.arrivalFrom)
    newData["arrival_datetime[from]"] = filters.arrivalFrom.format(
      "YYYY-MM-DD 00:00:00"
    );
  if (filters.arrivalTo)
    newData["arrival_datetime[to]"] = filters.arrivalTo.format(
      "YYYY-MM-DD 23:59:59"
    );
  if (filters.weekDays) newData.day_of_week_key = filters.weekDays;

  if (filters.sort) {
    const { sort } = filters;
    if (sort.order) {
      newData[
        `sort[${sort.columnKey === "info" ? "number" : sort.columnKey}]`
      ] = sort.order === "ascend" ? "asc" : "desc";
    }
  }

  return newData;
};
